import { persistStore } from '@/composable';
import { State } from '@/models/store/user';

export const persistStoreUser = (): any => persistStore<State>('user');
